// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Karla:400,700);"]);
// Module
exports.push([module.id, ".card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  border: 1px solid rgba(0, 0, 0, 0.04);\n  border-radius: 0.25rem;\n}\n.card .card-header {\n  background-color: #fff;\n  border-bottom: none;\n}", ""]);
// Exports
module.exports = exports;
